import settings from '../conf/settings';
import axios from 'axios';
import qs from 'qs';

const { CORE_API_GATEWAY_URL } = settings.environment;

const instance = axios.create({});

export const validatePayment = (paymentId = '123', validationData = {refId: "", lastName: ""}) => {
  return instance.request({
    method: 'post',
    url: `${CORE_API_GATEWAY_URL}/payments/${paymentId}/validationAttempts`,
    data: validationData,
  })
};

export const fetchPaymentDetails = (paymentId = '123', validationToken) => {
  return instance.request({
    method: 'get',
    headers: {
      Authorization: `Bearer ${validationToken}`
    },
    url: `${CORE_API_GATEWAY_URL}/payments/${paymentId}`,
  })
};

export const fetchProgramConfiguration = (programId = '123', validationToken) => {
  return instance.request({
    method: 'get',
    headers: {
      Authorization: `Bearer ${validationToken}`
    },
    url: `${CORE_API_GATEWAY_URL}/programs/${programId}/configurations/recipientPortal`,
  })
};

export const fetchPaymentAccounts = (paymentId = '123', validationToken) => {
  return instance.request({
    method: 'get',
    headers: {
      Authorization: `Bearer ${validationToken}`
    },
    url: `${CORE_API_GATEWAY_URL}/payments/${paymentId}/accounts`,
  })
};

export const postRecipientLogin = (paymentId = '123', validationToken, paymentNetwork, additionalData) => {
  return instance.request({
    method: 'post',
    headers: {
      Authorization: `Bearer ${validationToken}`,
    },
    data: qs.stringify({
      "payment_network": paymentNetwork,
      ...additionalData,
    }),
    url: `${CORE_API_GATEWAY_URL}/payments/${paymentId}/recipientLogins`,
  })
};

export const postAcceptPayment = (paymentId = '123', recipientLoginToken, acceptPaymentData) => {
  return instance.request({
    method: 'post',
    headers: {
      Authorization: `Bearer ${recipientLoginToken}`,
    },
    url: `${CORE_API_GATEWAY_URL}/payments/${paymentId}/triggers/acceptance`,
    data: acceptPaymentData,
  });
};

export const fetchPaymentStatus = (paymentId = '123', recipientLoginToken) => {
  return instance.request({
    method: 'get',
    url: `${CORE_API_GATEWAY_URL}/payments/${paymentId}/status`,
    headers: {
      Authorization: `Bearer ${recipientLoginToken}`,
    },
  });
};

export const fetchProgramCss = cssFileName => {
  return axios.get(`/static/css/programs/${cssFileName}.css`)
    .catch(error => console.log(error))
};

export const getConvertedCurrency = ({
                                       fromCurrency = 'USD',
                                       toCurrency = 'USD',
                                       amount = 0,
                                     },
                                     token,
                                     ) => {
  return instance.request({
    method: 'get',
    url: `${CORE_API_GATEWAY_URL}/currencyconversions?from=${fromCurrency}&to=${toCurrency}&amount=${amount}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(response => Number(response.data.result))
};

export const healthCheck = () => {
  return instance.request({
    method: 'options',
    url: `${CORE_API_GATEWAY_URL}/_healthcheck`,
  })
};
